export const GET_CONTACT_ADMIN_INFO_INIT = 'GET_CONTACT_ADMIN_INFO_INIT';
export const GET_CONTACT_ADMIN_INFO_SUCCESS = 'GET_CONTACT_ADMIN_INFO_SUCCESS';
export const GET_CONTACT_ADMIN_INFO_FAILURE = 'GET_CONTACT_ADMIN_INFO_FAILURE';

export const SEND_CONTACT_MESSAGE_INIT = 'SEND_CONTACT_MESSAGE_INIT';
export const SEND_CONTACT_SUCCESS = 'SEND_CONTACT_SUCCESS';
export const SEND_CONTACT_FAILURE = 'SEND_CONTACT_FAILURE';